//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './VisitMailServiceSettingsClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetVisitMailServiceSettingsQueryParameters = {
  subtenantId: number ;
}

export type PatchVisitMailServiceSettingsQueryParameters = {
  subtenantId: number ;
}

export function getUrl(subtenantId: number): string {
  let url_ = getBaseUrl() + "/api/mail/settings/{subtenantId}";
if (subtenantId === undefined || subtenantId === null)
  throw new Error("The parameter 'subtenantId' must be defined.");
url_ = url_.replace("{subtenantId}", encodeURIComponent("" + subtenantId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.VisitMailSettingsDto, unknown, Types.VisitMailSettingsDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.VisitMailSettingsDto, unknown, Types.VisitMailSettingsDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(subtenantId: number): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { subtenantId,  } = params[0] as GetVisitMailServiceSettingsQueryParameters;

    return trimArrayEnd([
        'VisitMailServiceSettingsClient',
        'get',
        subtenantId as any,
      ]);
  } else {
    return trimArrayEnd([
        'VisitMailServiceSettingsClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.VisitMailSettingsDto, TError = unknown>(dto: GetVisitMailServiceSettingsQueryParameters, options?: Omit<UseQueryOptions<Types.VisitMailSettingsDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets Mail settings for a subtenant.
 */
export function useGetQuery<TSelectData = Types.VisitMailSettingsDto, TError = unknown>(subtenantId: number, options?: Omit<UseQueryOptions<Types.VisitMailSettingsDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.VisitMailSettingsDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.VisitMailSettingsDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let subtenantId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ subtenantId,  } = params[0] as GetVisitMailServiceSettingsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [subtenantId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.VisitMailSettingsDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(subtenantId),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.VisitMailSettingsDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets Mail settings for a subtenant.
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.VisitMailSettingsDto | undefined) => Types.VisitMailSettingsDto, subtenantId: number) {
  queryClient.setQueryData(getQueryKey(subtenantId),
    updater
  );
}

/**
 * Gets Mail settings for a subtenant.
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.VisitMailSettingsDto | undefined) => Types.VisitMailSettingsDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchUrl(subtenantId: number): string {
  let url_ = getBaseUrl() + "/api/mail/settings/{subtenantId}";
if (subtenantId === undefined || subtenantId === null)
  throw new Error("The parameter 'subtenantId' must be defined.");
url_ = url_.replace("{subtenantId}", encodeURIComponent("" + subtenantId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMutationKey(subtenantId: number): MutationKey {
  return trimArrayEnd([
      'VisitMailServiceSettingsClient',
      'patch',
      subtenantId as any,
    ]);
}

/**
 * Patches Mail settings for a subtenant.
 */
export function usePatchMutation<TContext>(subtenantId: number, options?: Omit<UseMutationOptions<void, unknown, Types.VisitMailSettingsPatchDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.VisitMailSettingsPatchDto, TContext> {
  const key = patchMutationKey(subtenantId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.VisitMailSettingsPatchDto) => Client.patch(subtenantId, dto),
    mutationKey: key,
  });
}
  
type Patch__MutationParameters = PatchVisitMailServiceSettingsQueryParameters & {
  dto: Types.VisitMailSettingsPatchDto;
}

/**
 * Patches Mail settings for a subtenant.
 */
export function usePatchMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Patch__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchVisitMailServiceSettingsQueryParameters}): UseMutationResult<void, unknown, Patch__MutationParameters, TContext> {
  const key = patchMutationKey(options?.parameters?.subtenantId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Patch__MutationParameters) => Client.patch(data.subtenantId ?? options?.parameters?.subtenantId!, data.dto),
  mutationKey: key,
});
}